<template>
 <div class="clearfix">
    <vs-input
      v-validate="'required|digits:6'"
      data-vv-validate-on="blur"
      name="verification_code"
      label-placeholder="Verification code"
      placeholder="Verification code"
      v-model="verification_code"
      class="w-full mt-6"
      counter="6" />
    <span class="text-danger text-sm">{{ errors.first('verification code') }}</span>
    <!-- <vs-button  type="border" to="/pages/login" class="mt-6">Login</vs-button> -->
    <vs-button class="float-right mt-6" @click="verify(verification_code)" :disabled="!validateForm">Continue</vs-button>
  </div>
</template>

<script>
import auth from '../../../services/authService';
import router from '@/router';

export default {
  data () {
    return {
      verification_code: ''
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any() && this.verification_code !== '' === true
    },
  },
  methods: {
    verify(code) {
      auth.verifyCode(code).then((response) => {
        router.push('/signup/details');
      }).catch(error => {
        this.$vs.notify({
          title: 'Verification Failed',
          text: "Invalid verification code",
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      });
    }
  }
}
</script>
